import * as React from 'react';

import i18n from 'helper/i18n';

import Dropdown, { OptionType } from 'components/atoms/Dropdown';

import { MEASUREMENT_DIAGRAM_TYPE, MeasurementDiagramTypeType } from 'store/dashboard/dashboard';

const options: OptionType[] = [
	{
		value: MEASUREMENT_DIAGRAM_TYPE.WEIGHT,
		label: i18n('react.impulsCoach.molecules.BoardTrendChooser.WEIGHT'),
	},
	{
		value: MEASUREMENT_DIAGRAM_TYPE.WAIST,
		label: i18n('react.impulsCoach.molecules.BoardTrendChooser.WAIST'),
	},
	{
		value: MEASUREMENT_DIAGRAM_TYPE.BODY_FAT,
		label: i18n('react.impulsCoach.molecules.BoardTrendChooser.BODY_FAT'),
	},
];

export type BoardTrendChooserType = {
	isLoading: boolean;
	selected: MeasurementDiagramTypeType;
	onChange: (selected: string) => void;
};

export const BoardTrendChooser = ({ selected, onChange, isLoading }: BoardTrendChooserType) => {
	const selectedOption = options.find((option) => option.value === selected);
	return (
		<div className="m-board-trend__chooser">
			<Dropdown
				id="BoardTrendChooser"
				options={options}
				value={selectedOption ? selectedOption.value : ''}
				disabled={isLoading}
				onChange={({ value }) => onChange(value.toString())}
				label={''}
			/>
		</div>
	);
};

BoardTrendChooser.displayName = 'BoardTrendChooser';

export default BoardTrendChooser;
